import { render } from "./TextfieldWithLabel.vue?vue&type=template&id=13553b50"
import script from "./TextfieldWithLabel.vue?vue&type=script&lang=js"
export * from "./TextfieldWithLabel.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\Vue_Webinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__